"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M16.148 7.8H7.852a.947.947 0 00-.952.94v6.52c0 .519.426.94.952.94h8.296a.947.947 0 00.952-.94V8.74c0-.519-.427-.94-.952-.94zM15.9 12H8.1V9h7.8v3z" }), "Cover");
//# sourceMappingURL=Cover.js.map